import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Eduardo Robles <dev@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ListApprovals } from "../Approvals/ListApprovals";
import { useRecordContext } from "react-admin";
import { ViewApproval } from "../Approvals/ViewApproval";
import { useElectionEventTallyStore } from "@/providers/ElectionEventTallyProvider";
var ViewMode;
(function (ViewMode) {
    ViewMode[ViewMode["View"] = 0] = "View";
    ViewMode[ViewMode["List"] = 1] = "List";
})(ViewMode || (ViewMode = {}));
export var EditElectionEventApprovals = function (_a) {
    var electionEventId = _a.electionEventId, electionId = _a.electionId, showList = _a.showList;
    var electionEventRecord = useRecordContext();
    var _b = useState(ViewMode.List), viewMode = _b[0], setViewMode = _b[1];
    var _c = useState(null), currApprovalId = _c[0], setCurrApprovalId = _c[1];
    var t = useTranslation().t;
    var _d = useElectionEventTallyStore(), taskId = _d.taskId, setTaskId = _d.setTaskId;
    var onViewApproval = function (id) {
        setViewMode(ViewMode.View);
        setCurrApprovalId(id);
        setTaskId(id);
    };
    var onViewList = function () {
        setViewMode(ViewMode.List);
    };
    useEffect(function () {
        if (showList) {
            setViewMode(ViewMode.List);
            setCurrApprovalId(null);
        }
    }, [showList]);
    useEffect(function () {
        if (!taskId) {
            setViewMode(ViewMode.List);
            setCurrApprovalId(null);
        }
    }, [taskId]);
    return (_jsx(_Fragment, { children: viewMode === ViewMode.List ? (_jsx(ListApprovals, { electionEventId: electionEventId, electionId: electionId, onViewApproval: onViewApproval, electionEventRecord: electionEventRecord })) : (_jsx(ViewApproval, { electionEventId: electionEventId, electionId: electionId, currApprovalId: currApprovalId, electionEventRecord: electionEventRecord, goBack: onViewList })) }));
};
